<button class="bg-transparent border-0 p-0 group-all-btn" (click)="toggleAllGroups()">
  <span class="icon" [class]="{'ic-add-20': !expandedGroups, 'ic-minus-20': expandedGroups}"></span>
</button>
